import { TDestinationSetting } from './apis/config_api/config_api_types';
import { TEventMetaData } from './constants/event_types/base_mable_event';
import { EDestinationType } from './interfaces';

/**
 * Datalayer State provides key states for the datalayer
 */
export enum EDatalayerState {
  /**
   * Created state means that datalayer has been created but not yet ready to accept events
   */
  created = 'created',
  /**
   * Error state means the datalayer has encountered an error and is unable to process any further events
   */
  error = 'error',
  /**
   *
   */
  notracking = 'notracking',
  /**
   * Pending state means the datalayer is waiting for initiailization to complete
   */
  pending = 'pending',
  /**
   * Ready State means the datalayer is ready to accept events and process them
   */
  ready = 'ready',

  /**
   * Uninitialized state means the datalayer has not been created yet
   */
  uninitialized = 'uninitialized',
}

export enum EActions {
  Consent = 'consent',
  Event = 'event',
  Init = 'init',
}

type IBusinessLogicSettings = {
  isBusinessLogicActiveForEDestinationType: (
    name: string,
    type: EDestinationType,
  ) => unknown;
  isBusinessLogicSupported: (
    name: string,
    type: EDestinationType,
    eventName: any,
  ) => unknown;
  settings: any;
};

export class BusinessLogicSettings implements IBusinessLogicSettings {
  settings: any;
  isBusinessLogicActiveForEDestinationType(
    name: string,
    type: EDestinationType,
  ): boolean {
    return this.settings[name].active && type;
  }
  isBusinessLogicSupported(
    name: string,
    type: EDestinationType,
    eventName: any,
  ): boolean {
    return (
      this.settings[name].supportedEvents.includes(eventName) &&
      this.settings[name].supportedDestinations.includes(type)
    );
  }
}
/**
 * !TODO: Need to define
 */
export type MableConfigData = {
  eventNeedsBusinessLogicApplied: (
    destinationName: string,
    eventName: string,
  ) => boolean;
  getBusinessLogicSettings: (blName: string) => BusinessLogicSettings;
  getConsentSettings: () => any;
  getDestinationSettings: () => TDestinationSetting[];
  getMetaData: () => TEventMetaData;
  isEventAllowed: (eventName: string) => boolean;
  isEventAllowedForDestination: (
    destinationName: string,
    eventName: string,
  ) => boolean;
  shouldSendDestinationReqEvent: (
    type: EDestinationType,
    eventName: any,
  ) => boolean;
  shouldSendDestReqEventToDestination: (
    destinationName: string,
    eventName: string,
  ) => boolean;
};
